<template>
  <div class="FIRE-TOAST-CONTAINER" :style="style">
    <transition name="SCALE" mode="out-in">
      <div v-if="message" class="FIRE-TOAST" selenium="toast-body">
        {{ message }}
        <a class="DISMISS" @click.prevent="dismiss" selenium="toast-close">
          <vk-icon name="close-slim" class="d-flex" size="14" />
        </a>
      </div>
    </transition>
  </div>
</template>

<script>
import Vue from 'vue';

export const FireToastEventBus = new Vue();

export default {
  name: 'fire-toast',
  data () {
    return {
      message: '',
      style: undefined,
    };
  },
  mounted () {
    FireToastEventBus.$on('message', this.onMessage);
  },
  destroyed () {
    FireToastEventBus.$off('message', this.onMessage);
  },
  methods: {
    onMessage ({ delay, message, dismiss, style }) {
      this.message = message;
      this.dismiss = dismiss;
      this.style = style;

      delay.then(() => {
        this.message = '';
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";

  @import "~@/views/Dashboard/constants";

  .FIRE-TOAST-CONTAINER {
    position: sticky;
    display: flex;
    flex-direction: column;
    align-items: center;
    top: 0;
    width: 100%;
    height: 0;
    // TODO: Handle z-indeces globally.
    z-index: 666;
  }

  .FIRE-TOAST {
    @include responsive(max-width, calc(100% - 32px), $md: calc(100% - 80px));
    @include text-medium;
    position: relative;
    display: flex;
    min-height: 40px;
    flex: 0 0 auto;
    padding: $unit 6*$unit $unit 2*$unit;
    margin: 3*$unit 0 0 0;
    color: $color-gray90;
    font-weight: 600;
    border-radius: 2px;
    border: 1px solid #73D13D;
    background-color: #F6FFED;
    overflow-wrap: break-word;
    word-break: break-word;
  }

  .DISMISS {
    @include absolute(50%, 2*$unit);
    @include square(14px);
    @include h4;
    display: flex;
    transform: translateY(-50%);
  }

  .SCALE-enter-active,
  .SCALE-leave-active {
    opacity: 1;
    transform: none;
    will-change: opacity, transform;
    transition: opacity $transition-duration, transform $transition-duration;

    &.SCALE-enter,
    &.SCALE-leave-to {
      opacity: 0;
      transform: scale(0);
    }
  }
</style>
